

<div id="myCarousel" *ngIf="allHomeHeros" class="carousel slide mb-6" data-bs-ride="carousel">

  <div class="carousel-inner">
    <div class="carousel-item active" *ngFor="let item of allHomeHeros; let i = index">
      <a href="{{item.linkWhatsapp}}" target="_blank">

        <img src="{{imgUrl}}{{ item.imagenUrl }}" alt="banner" fill>
        <div class="container">
          <div class="carousel-caption text-start">
          </div>
        </div>
      </a>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
